import { queryOptions } from "@tanstack/react-query";

import { apiFetch } from "../lib/api";
import type {
  PaymentOrderDetailResponse,
  PaymentOrderListResponse,
  ValidationQueuedResponse,
} from "./types";

export const paymentOrdersQueryOptions = queryOptions({
  queryKey: ["payment-orders"],
  queryFn: () => apiFetch<PaymentOrderListResponse>("/payment-orders"),
});

export const paymentOrderDetailQueryOptions = (emailId: string) =>
  queryOptions({
    queryKey: ["payment-orders", emailId, "detail"],
    queryFn: () =>
      apiFetch<PaymentOrderDetailResponse>(`/payment-orders/${emailId}`),
  });

export function requestPaymentOrderValidation(
  emailId: string,
): Promise<ValidationQueuedResponse> {
  return apiFetch<ValidationQueuedResponse>(
    `/payment-orders/${emailId}/validate`,
    { method: "POST" },
  );
}
